import { render, staticRenderFns } from "./EditGeofenceModal.vue?vue&type=template&id=5ff6d579&scoped=true&"
import script from "./EditGeofenceModal.vue?vue&type=script&lang=js&"
export * from "./EditGeofenceModal.vue?vue&type=script&lang=js&"
import style0 from "./EditGeofenceModal.vue?vue&type=style&index=0&id=5ff6d579&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff6d579",
  null
  
)

export default component.exports